import axios, { type AxiosInstance } from "axios";

let _token: string = "";

export const SESSION_EXPIRED_EVENT = "session-expired";

export class ServiceBase {
  axios: AxiosInstance;
  // Evita disparar múltiplos redirecionamentos quando várias requisições
  // retornam 401 quase simultaneamente.
  private static isHandlingUnauthorized = false;

  constructor() {
    const url =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_API_BASE_DEV_URL
        : process.env.REACT_APP_API_BASE_URL;

    this.axios = axios.create({
      baseURL: url,
    });

    this.axios.interceptors.request.use((config: any) => {
      const tokenSessionStorage = sessionStorage.getItem("Token");
      const token = _token;

      if (token !== "") {
        config.headers.Authorization = "Bearer " + token;
      }

      if (tokenSessionStorage !== null && token === "") {
        config.headers.Authorization = "Bearer " + tokenSessionStorage;
      }
      return config;
    });

    this.axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401) {
          // Token expirado ou inválido: limpa o token e o usuário da sessão.
          _token = "";
          sessionStorage.removeItem("Token");
          sessionStorage.removeItem("User");
          sessionStorage.removeItem("jwtAuth");

          if (!ServiceBase.isHandlingUnauthorized) {
            ServiceBase.isHandlingUnauthorized = true;
            // Notifica a aplicação para exibir a mensagem e redirecionar ao login.
            window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT));
          }
        }
        return Promise.reject(error);
      }
    );
  }

  post(url: string, data: any | null) {
    return this.axios.post(url, data);
  }

  patch(url: string, data: any) {
    return this.axios.patch(url, data);
  }

  get(url: string) {
    return this.axios.get(url);
  }

  getWithParams(url: string, params: URLSearchParams) {
    return this.axios.get(url, { params });
  }

  put(url: string, data: any) {
    return this.axios.put(url, data);
  }
  delete(url: string) {
    return this.axios.delete(url);
  }

  setToken(token: string) {
    _token = token;
  }
}